import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import config from '@/utils/themeConfig';
import avatar from '@/assets/images/logo/avatar.png';

const colors = config.colors; // Accès aux couleurs
const themeConfig = config.themeConfig; // Accès aux couleurs

const userDefaults = {
  id: 0,
  name : "John Doe",
  photo    : avatar,
  curr_project: {id: 0, name: "Projet0", role:4}
}

const state = {
    AppActiveUser           : userDefaults,
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    starredPages            : navbarSearchAndPinList["pages"].data.filter((page:any) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,
    windowWidth: null,
}

export default state
